import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <span>© {new Date().getFullYear()} Piixel — Describe it. Ship it. Keep it.</span>
      <span className="footer-links">
        <a href="/#features">Features</a>
        <a href="/#compare">How it works</a>
        <a href="/#visual-editor">Visual editor</a>
        <a href="/#pricing">Pricing</a>
        <Link to="/updates">Updates</Link>
        <Link to="/terms-of-service">Terms</Link>
        <Link to="/privacy-policy">Privacy</Link>
        <Link to="/refund-policy">Refunds</Link>
        <a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a>
      </span>
    </footer>
  );
}
